export { default } from './NextLink';
